// DeleteConfirmation.js
import React from 'react';
import styles from "../../TemplateManagement.module.css"
import { LFade, LDialog, LButton } from "@loffa/gpp-modules";

const DeleteConfirmation = ({ isOpen, onClose, onConfirm, title = "Confirm Delete", message = "Are you sure you want to delete this item? This action cannot be undone." }) => {
  if (!isOpen) return null;

  const actionBody = (
    <>
      <LButton
        onClick={onClose}
        themeColor="primary"
      >
        Cancel
      </LButton>
      <LButton
        onClick={onConfirm}
        className="red"
      >
        Delete
      </LButton>
    </>
  );

  return (
    <LFade transitionEnterDuration={300}>
      {isOpen && (
        <LDialog
          width='700'
          title={title}
          subtitle={`Confirm Delete`}
          body={
            <div className={styles.templateManagerModalBody}>
              <p>{message}</p>
            </div>
          }
          action={actionBody}
          actionCloseButton={onClose}
          actionOverlay={onClose}
        />
      )}
    </LFade>
  );
};

export { DeleteConfirmation };